import { Link } from "react-router-dom";

/* MATERIAL TAILWIND COMPONENTS */
import { Button } from "@material-tailwind/react";

const BlogBox = (props) => {
  return (
    <Link to={props.link}>
      <div className="h-full bg-white border border-greyBorder rounded-md shadow">
        <img
          src={props.image}
          className="w-full h-[25vh] object-cover rounded-t-md"
          alt={props.title}
        />
        <div className="p-5">
          <h5 className="text-lg font-fraunces-bold text-black tracking-tight leading-tight">
            {props.title}
          </h5>
          <p className="text-base font-source font-normal text-textGrey mt-3">
            {props.desc}
          </p>
          <Link to={props.link} className="block mt-3">
            <Button className="shadow-none hover:shadow-none text-sm font-source font-semibold text-white px-5 py-2 rounded-md bg-black hover:bg-opacity-80 transition-all duration-300 ease-in-out normal-case">
              Read more
            </Button>
          </Link>
        </div>
      </div>
    </Link>
  );
};

export default BlogBox;
